import httpClient from './_httpClient';

const END_POINT = '/sms-settings';
function endpoint(scopeId) {
  return "/scopes/" + scopeId + END_POINT;
}

const getSmsSettingsByScope = (scopeId) => httpClient.get(endpoint(scopeId));
const updateSmsSettings = (scopeId, smsSettingId, smsSettings) => httpClient.put(endpoint(scopeId)+ '/'+ smsSettingId, smsSettings);
const getSmsSender= (scopeId) => httpClient.get('senders/'+scopeId);
export {
  getSmsSettingsByScope,
  updateSmsSettings,
  getSmsSender
}
